import type { OrganizationDetails } from "~vue/appTypes";
import PerspectiveSurvey from "~vue/Perspective/PerspectiveSurvey.vue";
import PerspectiveSurveyLegacy from "~vue/Perspective/PerspectiveSurveyLegacy.vue";
import { computed, inject, type Ref } from "vue";

/** Picks the survey for the perspective_survey_slider flag; both take the same props, slots and exposed methods. */
export function usePerspectiveSurveyComponent() {
    const organizationDetails = inject<Ref<OrganizationDetails | null> | undefined>("organization_details", undefined);
    const sliderEnabled = computed(() => Boolean(organizationDetails?.value?.is_perspective_survey_slider_enabled));
    const surveyComponent = computed(() => (sliderEnabled.value ? PerspectiveSurvey : PerspectiveSurveyLegacy));
    return { sliderEnabled, surveyComponent };
}
